import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminRequestsPage } from "@/features/admin/requests";

/** Access requests (ALP-85): sign-ups waiting for review; `?id=` opens one (links from staff notifications). */
export const Route = createFileRoute("/admin/requests")({
  validateSearch: z.object({ id: z.string().uuid().optional(), status: z.enum(["new", "contacted", "approved", "rejected", "all"]).optional() }),
  head: () => ({ meta: [{ title: "Requests · Admin · Malfak" }] }),
  component: AdminRequestsPage,
});
